<div>
  <ng-container *ngIf="(Licenses$ | async) as licenses;">
    <ng-container *ngIf="(licenses | licenseFilter:'ABMP').length == 0">
      <p>If you have a state license that you need to display on your CE certificate, you can add that information
        below.</p>
      <form [formGroup]="licenseForm" (ngSubmit)="AddLicense()">
        <label class="mr-2" for="licensestate">State</label><select formControlName="state" class="mr-4">
          <option value="">--Select--</option>
          <ng-container *ngFor="let state of states">
            <option value="{{state}}">{{state}}</option>
          </ng-container>
        </select>
        <label class="mr-2" for="licensenumber">License Number</label><input formControlName="number" type="text"
          class="mr-4" />
        <input type="submit" value="Add License" class="btn btn-primary" [disabled]="!licenseForm.valid" />
      </form>
    </ng-container>
  </ng-container>
  <em *ngIf="licenseSaved">Your license information has been saved, and will now appear on your CE certificates.</em>
</div>
